import '../styles/AdvancedSearch.css';
import { useState } from 'react';
import { Icon, Spinner, DatePicker } from '@fluentui/react';
import { parseISO, format } from "date-fns";


const initialSearchFormInputsValues = {
    deponentName: "",
    courtName: "",
    courtDivisionName: "",
    dateFrom: "",
    dateTo: "",
    currentStatus: ""
}

const AdvancedSearch = ({ handleOpen, courts, courtDivisions, returnSearchResults }) => {
    //const handleApiRequest = useApiService();
    const [searchFormInputs, setSearchFormInputs] = useState(initialSearchFormInputsValues);
    const [courtDivisionsForCourt, setCourtDivisionsForCourt] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDateRequired, setIsDateRequired] = useState(false);

    const validateSearchFormInputs = () => {
        return Boolean(searchFormInputs.dateFrom && searchFormInputs.dateTo);
    };

    const handleDateSearchFormInputChange = (name, date) => {
        const updatedInputs = { ...searchFormInputs };

        if (date) {
            updatedInputs[name] = format(date, "yyyy-MM-dd");
            setSearchFormInputs(updatedInputs);
        }

        if (name === "dateFrom") {

            setIsDateRequired(!!date && !updatedInputs.dateTo);
        } else if (name === "dateTo" && date) {
            setIsDateRequired(false);
        }
    };

    const handleSearchFormInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;

        if (inputName === "courtName") {
            const selectedCourt = courts.find((court) => court.courtName === inputValue);
            setSearchFormInputs({ ...searchFormInputs, [inputName]: inputValue, courtDivisionName: "" });
            const courtDivisionsForSelectedCourt = courtDivisions.filter(
                (division) => division.courtId === selectedCourt.id
            );
            courtDivisionsForSelectedCourt.unshift({ id: 0, courtDivisionName: "All" });
            setCourtDivisionsForCourt(courtDivisionsForSelectedCourt);
        } else {
            setSearchFormInputs({ ...searchFormInputs, [inputName]: inputValue });
        }
    };

    const handleClear = () => {
        setSearchFormInputs(initialSearchFormInputsValues);
    };

    // Hand the search CRITERIA up to the parent. The parent owns the API call and
    // pagination, so search results page exactly like the normal list.
    const handleSearchFormSubmit = () => {
        if (!validateSearchFormInputs()) {
            return;
        }
        setIsSubmitting(true);
        const { deponentName, courtName, courtDivisionName, dateFrom, dateTo, currentStatus } = searchFormInputs;


        const criteria = {
            deponentName,
            courtName: courtName !== "All" ? courtName : "",
            courtDivision: courtDivisionName !== "All" ? courtDivisionName : "",
            startDate: dateFrom,
            endDate: dateTo,
            status: currentStatus,
            user: "Admin"
        };

        returnSearchResults(criteria);
        setSearchFormInputs(initialSearchFormInputsValues);
        handleOpen();
        setIsSubmitting(false);
    };


    return (
        <div className="panel-overlay" id="panelOverlay">
            <div className="panel">
                <div className="panel-header-wrapper">
                    <div className="panel-header-text">Advanced Search</div>
                    <Icon
                        iconName="Cancel"
                        styles={{
                            root: {
                                fontSize: 18,
                                color: '#006400',
                                ':hover': {
                                    color: '#1c2313',
                                    fontSize: 19,
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }
                            }
                        }}
                        onClick={handleOpen}
                    />
                </div>

                <div className="panel-body-wrapper">
                    <div className='a-search-date-inputs-wrapper'>
                        <div className='a-search-input-container'>
                            <label htmlFor="dateFrom">Date From:</label>
                            <DatePicker
                                placeholder='dd-mmm-yyyy'
                                formatDate={(date) => format(date, "dd-MMM-yyyy")}
                                id="dateFrom"
                                value={searchFormInputs.dateFrom ? parseISO(searchFormInputs.dateFrom) : null} // Convert string to Date object
                                onSelectDate={(date) => handleDateSearchFormInputChange("dateFrom", date)}
                                styles={{ root: { width: '100%', textAlign: 'left' } }}
                            />
                        </div>

                        <div className='a-search-input-container'>
                            <label htmlFor="dateTo">Date To:</label>
                            <DatePicker
                                styles={{ root: { width: '100%', textAlign: 'left' } }}
                                name="dateTo"
                                id="dateTo"
                                placeholder='dd-mmm-yyyy'
                                isRequired={isDateRequired}
                                formatDate={(date) => format(date, "dd-MMM-yyyy")}
                                value={searchFormInputs.dateTo ? parseISO(searchFormInputs.dateTo) : null} // Convert string to Date object
                                disabled={!searchFormInputs.dateFrom}
                                minDate={searchFormInputs.dateFrom ? parseISO(searchFormInputs.dateFrom) : null} // Ensure minDate is a Date object
                                onSelectDate={(date) => handleDateSearchFormInputChange("dateTo", date)}
                            />
                        </div>
                    </div>
                    <div className='a-search-input-container'>
                        <label htmlFor="courtName">Court Name:</label>
                        <select
                            name="courtName"
                            id="courtName"
                            value={searchFormInputs.courtName}
                            onChange={handleSearchFormInputChange}
                        >
                            <option value="" disabled hidden>
                                All Courts
                            </option>
                            {courts.map((court) => {
                                return <option value={court.courtName} key={court.id}>{court.courtName}</option>
                            })}
                        </select>
                    </div>

                    <div className='a-search-input-container'>
                        <label htmlFor="courtDivisionName">Court Division:</label>
                        <select
                            name="courtDivisionName"
                            id="courtDivisionName"
                            value={searchFormInputs.courtDivisionName}
                            onChange={handleSearchFormInputChange}
                            disabled={!searchFormInputs.courtName}
                        >
                            <option value="" disabled hidden>
                                All Divisions
                            </option>
                            {courtDivisionsForCourt.map((division) => {
                                return <option value={division.courtDivisionName} key={division.id}>{division.courtDivisionName}</option>
                            })}
                        </select>
                    </div>

                    <div className='a-search-input-container'>
                        <label htmlFor="deponentName">Deponent Name:</label>
                        <input
                            type="text"
                            name="deponentName"
                            id="deponentName"
                            value={searchFormInputs.deponentName}
                            placeholder="Please enter deponent Name"
                            onChange={handleSearchFormInputChange}
                        />
                    </div>

                    <div className='a-search-input-container'>
                        <label htmlFor="currentStatus">Current Status:</label>
                        <select
                            name="currentStatus"
                            id="currentStatus"
                            value={searchFormInputs.currentStatus}
                            onChange={handleSearchFormInputChange}
                        >
                            <option value="" disabled hidden>
                                All Status
                            </option>
                            <option value="Pending" key={1}>Pending</option>
                            <option value="Rejected" key={2}>Rejected</option>
                            <option value="Approved" key={3}>Approved</option>
                            <option value="Cancelled" key={4}>Cancelled</option>
                        </select>
                    </div>

                    <div className='panel-buttons-wrapper'>
                        <button
                            type="submit"
                            className="a-search-btn"
                            onClick={handleClear}
                        >Clear</button>

                        <button
                            type="submit"
                            className="a-search-btn"
                            onClick={handleOpen}
                        >Close</button>

                        <button
                            type="button"
                            className="a-search-btn a-submit-btn"
                            onClick={handleSearchFormSubmit}
                            disabled={isSubmitting ? true : !validateSearchFormInputs()}
                        >Search {isSubmitting ? <span><Spinner /></span> : ""}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdvancedSearch;